export interface Language {
  code: string
  english: string,
  name: string
}

export const languages: Language[] = [
  { code:"ar", english: "Arabic", name: "العَرَبِيَّة" },
  { code:"en", english: "English", name:"English" },
  { code:"cs", english: "Czech", name:"Čeština" },
  { code:"da", english: "Danish", name:"Dansk" },
  { code:"de", english: "German", name:"Deutsch" },
  { code:"de-CH", english: "German - Switzerland", name:"Deutsch - Schweiz" },
  { code:"el", english: "Greek", name:"Ελληνικά" },
  { code:"es", english: "Spanish", name:"Español" },
  { code:"fr-CA", english: "French - Canada", name:"Français - Canada" },
  { code:"fi", english: "Finnish", name:"Suomi" },
  { code:"fr", english: "French", name:"Français" },
  { code:"fr-CH", english: "French - Switzerland", name:"Français - Suisse" },
  { code:"hr", english: "Croatian", name:"Hrvatski" },
  { code:"hu", english: "Hungarian", name:"Magyar" },
  { code:"it", english: "Italian", name:"Italiano" },
  { code:"he", english: "Hebrew", name:"עברית" },
  { code:"ja", english: "Japanese", name:"日本語" },
  { code:"ko", english: "Korean", name:"한국어" },
  { code:"nb", english: "Norwegian - Bokmal", name:"Norsk bokmål" },
  { code:"nl", english: "Dutch", name:"Nederlands" },
  { code:"no", english: "Norwegian", name:"Norsk" },
  { code:"pt-BR", english: "Portuguese - Brazil", name:"Português - Brasil" },
  { code:"pl", english: "Polish", name:"Polski" },
  { code:"pt", english: "Portuguese", name:"Português" },
  { code:"ru", english: "Russian", name:"Русский" },
  { code:"sk", english: "Slovak", name:"Slovenčina" },
  { code:"sl", english: "Slovenian", name:"Slovenščina" },
  { code:"sr", english: "Serbian", name:"Srpski" },
  { code:"sv", english: "Swedish", name:"Svenska" },
  { code:"th", english: "Thai", name:"ภาษาไทย" },
  { code:"tr", english: "Turkish", name:"Türkçe" },
  { code:"uk", english: "Ukrainian", name:"Українська" },
  { code:"zh-TW", english: "Chinese - Traditional", name:"繁體中文" },
  { code:"zh-CN", english: "Chinese - Simplified", name:"简体中文" }
]

const localizedLanguageList= ['de', 'en', 'es', 'fr', 'it', 'ja', 'ko', 'pl', 'pt-BR', 'ru', 'th', 'zh-CN', 'zh-TW'];

export function getLocalizedLanguages(): Language[] {
  return languages.filter( lang => {
    return localizedLanguageList.indexOf(lang.code) !== -1;
  }).sort((a, b) => a.english > b.english ? 1 : -1)
}

export function find(code:string): Language|undefined {
  return languages.find(l => l.code === code)
}